import { connect } from 'react-redux';

import queryString from 'query-string';

import i18n from 'shared/lib/i18n';

import SetPasswordComponent from './SetPasswordComponent';

import { AUTH_SET_PASSWORD, DELETE_BRANCH_DATA } from '../../actionConstants';
import { logout } from './actionCreators';

import apiClient from '../../apiClient';
import { history } from '../../store';

const form = 'SetPassword';

const mapStateToProps = (state, ownProps) => {
  const initialValues = {};
  const params = queryString.parse(ownProps?.location?.search);
  initialValues.token = params?.token;
  initialValues.uid = params?.uid;
  return {
    form,
    initialValues,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoad: () => {
    document.title = i18n.t('actions.setPassword');
  },
  onSubmit: (data) => {
    const isReset = ownProps?.match?.url?.includes('reset');

    const formattedData = { ...data };
    formattedData.newPassword = data.password;

    const nextUrl = '/login';

    return dispatch({
      type: AUTH_SET_PASSWORD,
      isForm: true,
      successMessage: 'Password set!',
      payload: isReset
        ? apiClient.auth.confirmPassword(formattedData)
        : apiClient.auth.setPassword(data),
      callback: (res) => {
        isReset &&
          dispatch({
            type: DELETE_BRANCH_DATA,
          });
        if (res) {
          history.push(nextUrl);
        }
      },
    });
  },
  onUnmount: () => logout(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SetPasswordComponent);
